import { GATEWAY_ORIGIN } from '@/constants/environment';

/**
 * SSC API Configuration
 *
 * Single Service Calculator API provides insurance options for a given booking basket.
 * Authentication is handled by API Gateway (Login: {} empty object).
 */
export const SSC_CONFIG = {
  ENDPOINT: `${GATEWAY_ORIGIN}/ssc`,
  AGENCY_NUMBER: 1,
  LANGUAGE: 'de',
  BOOKING_SOURCE: 1,

  TIMEOUT: 20000, // 20 seconds

  RETRY: {
    maxAttempts: 1, // 1 retry = 2 total attempts max (SSC is supplementary)
    initialDelay: 500,
  },
} as const;

export const SSC_ENDPOINTS = {
  GET_INSURANCES: '/GetInsurances',
} as const;
